const EmailIntegrationIndex = () => import(/* webpackChunkName: 'EmailIntegrationIndex' */ '@/Email-Integrations/Index');
const ExchangeCallback = () => import(/* webpackChunkName: 'ExchangeCallback' */ '@/Email-Integrations/components/Connect/exchange/ExchangeCallback');
const GmailCallback = () => import(/* webpackChunkName: 'GoogleCallback' */ '@/Email-Integrations/components/Connect/google/GmailCallback');

export default [
  {
    path: '/email-integrations',
    name: 'integrations',
    component: EmailIntegrationIndex,
    meta: { auth: true },
  },
  {
    path: '/exchange-callback',
    name: 'exchange-callback',
    component: ExchangeCallback,
    meta: { auth: true },
  },
  {
    path: '/google-callback',
    name: 'google-callback',
    component: GmailCallback,
    meta: { auth: true },
  },
];
